import defaults from './_defaults.js';
import store from '~/scripts/store/index.js';

function makeTextTransformer(node, idx, stage, love = false, border = 'free', background = false, configuration = null) {
    let MIN_WIDTH = 20;
    let MIN_HEIGHT = 10;
    let layer = node.getLayer();
    let windowWidth = window.innerWidth || document.documentElement.clientWidth;
    let textConfiguration = background ? configuration : store.state.textConfigurations[idx];
    let tr = new Konva.Transformer({
        ...defaults.transformerConfiguration,
        name: background ? 'bg_text_transformer' : 'text_transformer',
        anchorSize: 30,
        anchorCornerRadius: 30,
        nodes: [node],
        padding: 5,
        rotateEnabled: false,
        anchorFill: 'transparent',
        borderStroke: 'transparent',
        // dont enable side anchors (we want to keep correct text size)
        enabledAnchors: ['top-left', 'top-right', 'bottom-left', 'bottom-right'],
        // limit transformer bounds
        boundBoxFunc: (oldBox, newBox) => {
            if (newBox.width < MIN_WIDTH) {
                return oldBox;
            }
            if (newBox.height < MIN_HEIGHT) {
                return oldBox;
            }
            return newBox;
        },
    });

    layer.add(tr);
    layer.batchDraw();

    node.on('dragstart', () => {
        // draw centered line to current text element
        const textHelperLineV = layer.findOne('#text-helper-line-v');
        if (!textHelperLineV) {
            var line = new Konva.Line({
                points: [0, -6000, 0, 6000],
                stroke: 'rgb(0, 161, 255)',
                strokeWidth: 1,
                id: 'text-helper-line-v',
                dash: [4, 6],
                x: node.getX() + ((node.width() * node.scaleX()) / 2),
                y: node.getY(),
            });
            layer.add(line);
            layer.batchDraw();
        }

        const textHelperLineH = layer.findOne('#text-helper-line-h');
        if (!textHelperLineH) {
            var line = new Konva.Line({
                points: [-6000, 0, 6000, 0],
                stroke: 'rgb(0, 161, 255)',
                strokeWidth: 1,
                id: 'text-helper-line-h',
                dash: [4, 6],
                x: node.getX(),
                y: node.getY() + ((node.height() * node.scaleY()) / 2),
            });
            layer.add(line);
            layer.batchDraw();
        }
    });

    node.on('dragmove', () => {
        const textHelperLineV = layer.findOne('#text-helper-line-v');
        if (textHelperLineV) {
            textHelperLineV.x(node.getX() + ((node.width() * node.scaleX())/ 2));
        }

        const textHelperLineH = layer.findOne('#text-helper-line-h');
        if (textHelperLineH) {
            textHelperLineH.y(node.getY() + ((node.height() * node.scaleY()) / 2));
        }
    });

    node.on('dragend', () => {
        textConfiguration.dragged = true;

        if (!background) {
            textConfiguration.x = node.getX();
            textConfiguration.y = node.getY();
        } else {
            textConfiguration.text_x = node.getX();
            textConfiguration.text_y = node.getY();
        }

        const textHelperLineV = layer.findOne('#text-helper-line-v');
        if (textHelperLineV) {
            textHelperLineV.destroy();
        }

        const textHelperLineH = layer.findOne('#text-helper-line-h');
        if (textHelperLineH) {
            textHelperLineH.destroy();
        }
    });

    node.on('transform', () => {
        showTransformer(tr, windowWidth);
        if (!background) {
            textConfiguration.x = node.getX();
            textConfiguration.y = node.getY();
            textConfiguration.scaleX = node.scaleX();
            textConfiguration.scaleY = node.scaleY();
        } else {
            textConfiguration.text_x = node.getX();
            textConfiguration.text_y = node.getY();
            textConfiguration.text_scaleX = node.scaleX();
            textConfiguration.text_scaleY = node.scaleY();
        }
    });
    node.on('transformend',  () => {
        if (!background) {
            textConfiguration.dragged = true;
            textConfiguration.scaleX = node.scaleX();
            textConfiguration.scaleY = node.scaleY();

            document.getElementById('ayv-container').dispatchEvent(new CustomEvent('textScaleChanged', {
                detail: {
                    idx: idx,
                    textConfiguration: textConfiguration
                }
            }));
        } else {
            textConfiguration.text_scaleX = node.scaleX();
            textConfiguration.text_scaleY = node.scaleY();

            document.getElementById('ayv-container').dispatchEvent(new CustomEvent('backgroundTextScaleChanged'));
        }

        hideTransformer(tr, windowWidth);
    });

    node.on('mouseenter', () => {
        showTransformer(tr, windowWidth);
    });
    node.on('mouseleave', () => {
        hideTransformer(tr, windowWidth);
    });

    tr.on('mouseenter', () => {
        showTransformer(tr, windowWidth);
    });
    tr.on('mouseleave', () => {
        hideTransformer(tr, windowWidth);
    });

    layer.on('dragstart', (e) => {
        // get guide stops
        var lineGuideStops = getLineGuideStops(e.target, stage, love, border);
        if (!store.state.textGuidesDrawn) {
            drawHelpers(lineGuideStops, layer);
        }
    });

    layer.on('dragend', function (e) {
        // clear all previous lines on the screen
        store.commit('updateField', {
            path: 'textGuidesDrawn',
            value: false
        });

        if (background) {
            textConfiguration.text_x = node.getX();
            textConfiguration.text_y = node.getY();
        }

        layer.find('.guid-line').destroy();
        layer.batchDraw();
    });

    return tr;
}

function showTransformer(tr, windowWidth) {
    if (windowWidth > 1024) {
        try {
            tr.borderStroke(defaults.transformerConfiguration.borderStroke);
            tr.anchorFill(defaults.transformerConfiguration.anchorFill);
        } catch (error) {}
    }
}

function hideTransformer(tr, windowWidth) {
    if (windowWidth > 1024) {
        try {
            tr.borderStroke('transparent');
            tr.anchorFill('transparent');
        } catch (error) {}
    }
}

function getLineGuideStops(skipShape, stage, love, border) {
    // we can snap to stage borders and the center of the stage
    var borderWidth = border === 'border' ? defaults.stageBorderWidthVisible : defaults.stageBorderWidth;
    var vertical = [Math.round(stage.width() / 2)];
    var horizontal = [Math.round(stage.height() / 2)];

    if (love) {
        var quarterStage = ((stage.width() - (borderWidth * 2)) / 4);
        vertical.push(Math.round(quarterStage + borderWidth));
        vertical.push(Math.round(quarterStage + (stage.width() / 2)));
    }

    return {
        vertical: vertical.flat(),
        horizontal: horizontal.flat(),
    };
}

// what points of the object will trigger to snapping?
// it can be just center of the object
// but we will enable all edges and center
function getObjectSnappingEdges(node) {
    var box = node.getClientRect();
    var absPos = node.absolutePosition();

    return {
        vertical: [
            {
                guide: Math.round(box.x),
                offset: Math.round(absPos.x - box.x),
                snap: 'start',
            },
            {
                guide: Math.round(box.x + box.width / 2),
                offset: Math.round(absPos.x - box.x - box.width / 2),
                snap: 'center',
            },
            {
                guide: Math.round(box.x + box.width),
                offset: Math.round(absPos.x - box.x - box.width),
                snap: 'end',
            },
        ],
        horizontal: [
            {
                guide: Math.round(box.y),
                offset: Math.round(absPos.y - box.y),
                snap: 'start',
            },
            {
                guide: Math.round(box.y + box.height / 2),
                offset: Math.round(absPos.y - box.y - box.height / 2),
                snap: 'center',
            },
            {
                guide: Math.round(box.y + box.height),
                offset: Math.round(absPos.y - box.y - box.height),
                snap: 'end',
            },
        ],
    };
}

// find all snapping possibilities
function getGuides(lineGuideStops, itemBounds) {
    var resultV = [];
    var resultH = [];

    lineGuideStops.vertical.forEach((lineGuide) => {
        itemBounds.vertical.forEach((itemBound) => {
            var diff = Math.abs(lineGuide - itemBound.guide);
            // if the distance between guild line and object snap point is close we can consider this for snapping
            if (diff < 5) {
                resultV.push({
                    lineGuide: lineGuide,
                    diff: diff,
                    snap: itemBound.snap,
                    offset: itemBound.offset,
                });
            }
        });
    });

    lineGuideStops.horizontal.forEach((lineGuide) => {
        itemBounds.horizontal.forEach((itemBound) => {
            var diff = Math.abs(lineGuide - itemBound.guide);
            if (diff < 5) {
                resultH.push({
                    lineGuide: lineGuide,
                    diff: diff,
                    snap: itemBound.snap,
                    offset: itemBound.offset,
                });
            }
        });
    });

    var guides = [];

    // find closest snap
    var minV = resultV.sort((a, b) => a.diff - b.diff)[0];
    var minH = resultH.sort((a, b) => a.diff - b.diff)[0];
    if (minV) {
        guides.push({
            lineGuide: minV.lineGuide,
            offset: minV.offset,
            orientation: 'V',
            snap: minV.snap,
        });
    }
    if (minH) {
        guides.push({
            lineGuide: minH.lineGuide,
            offset: minH.offset,
            orientation: 'H',
            snap: minH.snap,
        });
    }
    return guides;
}

function drawHelpers(stops, layer) {
    store.commit('updateField', {
        path: 'textGuidesDrawn',
        value: true
    });

    if (stops.horizontal) {
        stops.horizontal.forEach((y) => {
            var line = new Konva.Line({
                points: [-6000, 0, 6000, 0],
                stroke: 'rgb(0, 161, 255)',
                strokeWidth: 1,
                name: 'guid-line',
                dash: [4, 6],
                x: 0,
                y: y,
            });
            layer.add(line);
            layer.batchDraw();
        });
    }

    if (stops.vertical) {
        stops.vertical.forEach((x) => {
            var line = new Konva.Line({
                points: [0, -6000, 0, 6000],
                stroke: 'rgb(0, 161, 255)',
                strokeWidth: 1,
                name: 'guid-line',
                dash: [4, 6],
                x: x,
                y: 0,
            });
            layer.add(line);
            layer.batchDraw();
        });
    }
}

export default makeTextTransformer;
